import initBuyButtons from '../global/initBuyButtons';
import initCarousel from '../helpers/carousel';
import { getTranslation, reinitSwymActionButtons } from '../helpers';

const selectors = {
  relatedProducts: '[data-related-products]',
  complementaryProducts: '[data-complementary-products]',
};

export default class DynamicProductFeed {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.limit || 8;

    initCarousel(this.el, {
      pagination: false,
    });
    this.addRecommendedProducts();
    this.addComplementaryProducts();
  }

  renderEmptyMessage(message) {
    return `<h3 class="py-24 type-heading-4 text-center">${message}</h3>`;
  }

  addRecommendedProducts() {
    const collectionContentContainer = this.el.querySelector(
      selectors.relatedProducts,
    );

    // If doesnt have data-product-id or related-products attr on container do nothing
    if (!collectionContentContainer) {
      return;
    }
    this.recommendationsFetch(selectors.relatedProducts);
  }

  addComplementaryProducts() {
    const collectionContentContainer = this.el.querySelector(
      selectors.complementaryProducts,
    );
    // If doesnt have data-product-id or related-products attr on container do nothing
    if (!collectionContentContainer) {
      return;
    }

    this.recommendationsFetch(
      selectors.complementaryProducts,
      '&intent=complementary',
    );
  }

  recommendationsFetch(selector, additionalQuery = '') {
    const container = this.el.querySelector(selector);
    const url = `${Shopify.routes.root}recommendations/products?section_id=${this.section.id}&limit=${this.limit}&product_id=${this.productId}${additionalQuery}`;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector(selector);

        if (!recommendations) {
          return;
        }

        // If there are no splide slides for complementary products, display error
        // TODO: update to static string message.
        // add to json schema
        if (
          !recommendations.querySelector('.splide__slide') &&
          additionalQuery
        ) {
          container.innerHTML = this.renderEmptyMessage(
            getTranslation('product_feed.no_complementary_products'),
          );
          return;
        }

        if (recommendations && recommendations.innerHTML.trim().length) {
          container.innerHTML = recommendations.innerHTML;
          initCarousel(this.el, {
            pagination: false,
          });
          initBuyButtons(container);
          reinitSwymActionButtons(container);
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  }
}
